import React, { useRef } from 'react';
import uploadLogo from '../assets/upload.svg';
import trashIcon from '../assets/trash.svg';

interface UploadFileSmallProps {
    handleMediaChange: (
        e: React.ChangeEvent<HTMLInputElement>,
        networkKey?: string,
        index?: number,
    ) => void;
    resetMedia: (index: number) => void;
    media: string;
    index: number;
    networkKey?: string;
    disabled: boolean;
    isViewMode?: boolean;
}
const trash = { path: trashIcon };

const UploadFileSmall: React.FC<UploadFileSmallProps> = ({
    handleMediaChange,
    resetMedia,
    media,
    index,
    networkKey,
    disabled,
    isViewMode = false,
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    if (isViewMode && !media) {
        return null;
    }

    return (
        <div className="relative flex bg-primary-light border border-dashed border-dark-gray rounded-[5px] w-[75px] h-[75px] content-center items-center flex-col font-montserrat overflow-hidden justify-evenly">
            {!media && (
                <>
                    <img
                        src={uploadLogo}
                        width="20"
                        height="20"
                        alt="upload-logo"
                        className={'mt-[6px]'}
                    />
                    <span className="text-center text-[10px]">Ajouter un fichier</span>
                    <span className="text-center text-[10px]">{'.jpg acceptés'}</span>
                </>
            )}
            {!isViewMode && (
                <input
                    type="file"
                    className="flex opacity-0 absolute w-full h-full top-0 left-0 z-10 cursor-pointer"
                    name={'mediaCarousel'}
                    accept={'image/jpg, image/jpeg'}
                    onChange={e => handleMediaChange(e, networkKey, index)}
                    onClick={e => e.stopPropagation()}
                    ref={fileInputRef}
                    id={`file-input-small-${index}-${networkKey}`}
                    disabled={disabled}
                />
            )}
            {media && (
                <div className="flex absolute w-full h-full bg-light-gray z-[100]">
                    {!isViewMode && (
                        <button
                            className="absolute flex top-[4px] left-[50px] w-[20px] h-[20px] rounded-[4px] m-0 p-0 z-[100] bg-white"
                            onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                resetMedia(index);
                            }}
                        >
                            <img
                                src={trash.path}
                                alt="trash icon"
                                className="flex items-center content-center justify-center text-center w-4 h-4 ml-[2px] mt-[2px] text-super-heavy font-small text-dark-gray z-[50]"
                                aria-hidden="true"
                            />
                        </button>
                    )}
                    <img
                        className="flex absolute w-full h-full z-[99] object-contain"
                        src={media}
                        alt={`Media ${index}`}
                    />
                </div>
            )}
        </div>
    );
};

export default UploadFileSmall;
